var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{attrs:{"id":_vm.tableId,"role":"tabpanel"},on:{"shown":_vm.onShown,"hidden":_vm.onHidden},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }